import { supabase } from '@/lib/supabase';
import { API_KEY_STATUS } from './constants';
import axiosInstance from '@/lib/axiosInstance';
import {
  CreateLLMApiKeyParams,
  CreateLLMApiKeyResponse,
  DeleteLLMApiKeyParams,
  GetLLMApiKeysParams,
} from './type';

export const getLLMApiKeys = async (params: GetLLMApiKeysParams = {}) => {
  let query = supabase
    .from('llm_api_key')
    .select()
    .in('api_key_status', [
      API_KEY_STATUS.DEFAULT,
      API_KEY_STATUS.NORMAL,
      API_KEY_STATUS.DISABLED,
    ]);

  if (params.workspace_id) {
    query = query.eq('workspace_id', params.workspace_id);
  }
  const { data, error } = await query;
  if (error) throw error;
  return data?.sort((a, b) => a.id - b.id);
};

export const createLLMApiKey = async (data: CreateLLMApiKeyParams) => {
  const result = await axiosInstance.post<CreateLLMApiKeyResponse>(
    '/llm-api/new',
    data
  );
  return result?.data;
};

export const deleteLLMApiKey = async (data: DeleteLLMApiKeyParams) => {
  const result = await axiosInstance.post<any>('/llm-api/delete', {
    api_key: data.id,
  });
  return result?.data;
};
